// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2OptK","title":"ClientReferral_title__30OrR","itemText":"ClientReferral_itemText__RGeLj"};